import { device } from '@/styles/common';
import { animate, motion } from 'framer-motion';
import styled from 'styled-components';

export const AnimatedSpacerContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <SpacerContainer
      initial={{ opacity: 0, y: 3, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 3, scale: 0.95 }}
      transition={{ duration: 0.225 }}
    >
      {children}
    </SpacerContainer>
  );
};

export const CenterFoldContainer = styled(motion.div)`
  position: relative;

  padding: 14px 24px;
  flex-grow: 1;

  flex: 1;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  transition: opacity 0.15s ease-in-out;

  @media ${device.mobileS} {
    padding: 14px 16px;
  }
`;

export const TitleText = styled.div`
  font-size: 35px;
  @media ${device.mobileS} {
    font-size: 30px;
  }
`;

export const TopText = styled.div`
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;

  color: #ffffff;

  a {
    color: #00bfff;
    cursor: pointer;
    transition: color 0.125s ease-in-out;
  }

  a:hover {
    color: #00adbb;
  }

  @media ${device.mobileS} {
    font-size: 14px;
  }
`;

export const ManaTopText = styled.div`
  font-size: 24px;
  line-height: 1.5;
  font-weight: 400;
  margin-top: 10px;

  color: #ffffff;

  a {
    color: #00bfff;
    cursor: pointer;
    transition: color 0.125s ease-in-out;
  }

  a:hover {
    color: #00adbb;
  }

  @media ${device.mobileS} {
    font-size: 14px;
  }
`;

export const SpacerContainer = styled(motion.div)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;
`;

export const FoldInput = styled.input`
  font-size: 48px;
  font-weight: 500;
  color: #ffffff;
  text-align: right;
  width: 100%;
  ${(props) =>
    props.disabled &&
    `
  opacity: .7;
`}
`;
export const FoldSymbol = styled.div`
  font-size: 22px;
  line-height: 40px;
  font-weight: 500;
  width: 50%;
  color: #ffffff;
`;

export const MaxButton = styled.div<{ onClick?: () => void }>`
  font-size: 14px;
  color: #c9c9c9;

  ${(props) =>
    props.onClick &&
    `&:hover {
    cursor: pointer;
    color: #ffffff;
  }`}
  margin-bottom: 15px;
  transition: color 0.225s ease-in-out;
`;

export const WethSwitch = styled.div<{ onClick?: () => void }>`
  font-size: 14px;
  color: #c9c9c9;
  margin-top: 20px;

  ${(props) =>
    props.onClick &&
    `&:hover {
    cursor: pointer;
    color: #ffffff;
  }`}

  transition: color 0.225s ease-in-out;
`;
